import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import ProjectDetail from './components/ProjectDetail';
import { projectsData } from './data/projectsData';

export default function ProjectPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const project = projectsData.find((p) => p.id === id);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!project) {
      navigate('/');
    }
  }, [id, project, navigate]);

  useEffect(() => {
    if (!project) return;
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    const pageUrl = `${siteUrl}/projects/${project.id}`;
    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Article',
          '@id': `${pageUrl}/#article`,
          headline: project.title,
          description: project.description,
          url: pageUrl,
          image: project.image,
          datePublished: `${project.year}-01-01`,
          author: {
            '@type': 'Organization',
            name: '株式会社永恒',
            url: siteUrl,
          },
          publisher: {
            '@type': 'Organization',
            name: '株式会社永恒',
            url: siteUrl,
          },
          about: {
            '@type': 'Service',
            name: project.relatedService,
          },
        },
        {
          '@type': 'WebPage',
          '@id': `${pageUrl}/#webpage`,
          url: pageUrl,
          name: `${project.title} | 施工実績 | 株式会社永恒`,
          description: project.description,
          inLanguage: 'ja',
          isPartOf: { '@id': `${siteUrl}/#website` },
        },
      ],
    };

    const existingScript = document.getElementById('schema-project');
    if (existingScript) existingScript.remove();
    const script = document.createElement('script');
    script.id = 'schema-project';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    document.title = `${project.title} | 施工実績 | 株式会社永恒`;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', project.description.slice(0, 160));
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', pageUrl);

    return () => {
      const s = document.getElementById('schema-project');
      if (s) s.remove();
    };
  }, [project]);

  if (!project) return null;

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ProjectDetail project={project} />
      <Footer />
    </div>
  );
}
